import React, {Component} from 'react';
import styles from './formPage.module.css';
import {updateObject} from '../../shared/utility';
import {connect} from 'react-redux';
import {startLoading, stopLoading} from '../../store/index';
import {formQuestions} from '../../constants/formQuestions.json';
import userService from '../../database/userService';
import promotionCodeService from '../../database/promotionCodeService';
import subscriptionService from '../../database/subscriptionService';
import {FORM_PAGES_NUMBERS} from '../../constants/formPages';

import SubscriptionDetails from '../../components/subscriptionDetails/subscriptionDetails';
import ContactDetais from '../../components/contactDetails/contactDetails';
import MedicalForm from '../../components/medicalForm/medicalForm';
import withLayout from '../../hoc/withLayout/withLayout';
import MainNavigationStepper from '../../components/mainNavigationStepper/mainNavigationStepper';
import OrderSummary from '../../components/orderSummary/orderSummary';
import SubscriptionPlaced from '../../components/subscriptionPlaced/subscriptionPlaced';
import {mapFoundPromotionCodeFromSnapshot} from '../../utils/firebase';
import InfoBar from '../../components/infoBar/infoBar';

class FormPage extends Component {
    state = {
        activePage: 0,
        medicalFormPage: 0,
        medicalFormValid: false,
        currentStepError: false,
        nextPageClicked: false,
        subscriptionDetails: {
            subscriptionBegin: '',
            subscriptionLength: 1,
            packingMethod: 'BOX',
            addBidon: false,
            addInfuser: false,
            email: '',
            isValid: false,
        },
        contactDetails: {
            name: '',
            surname: '',
            adress: '',
            city: '',
            zipCode: '',
            deliveryMethod: 'PICKUP',
            inPostCode: '',
            isValid: false,
        },
        foundPromotionCode: {},
        questions: [],
        monthlyPrice: 0,
        discountCode: '',
        discount: 0,
        totalPrice: 0,
        infoBarOpen: false,
        infoBarMessage: '',
    };

    componentDidMount() {
        this.setQuestionsInState();
        this.calculateMonthlyPrice();
    }

    calculateMonthlyPrice = () => {
        let newPrice = null;
        if (this.state.subscriptionDetails.subscriptionLength === 1) {
            newPrice = 39.99;
        } else if (this.state.subscriptionDetails.subscriptionLength === 3) {
            newPrice = 34.99;
        } else if (this.state.subscriptionDetails.subscriptionLength === 6) {
            newPrice = 34.99;
        } else if (this.state.subscriptionDetails.subscriptionLength === 12) {
            newPrice = 29.99;
        }
        this.calculateTotalPrice(newPrice);
        this.setState({
            monthlyPrice: newPrice,
        });
    };

    calculateTotalPrice = monthlyPrice => {
        let totalPrice =
            monthlyPrice * this.state.subscriptionDetails.subscriptionLength;
        if (this.state.contactDetails.deliveryMethod === 'INPOST') {
            totalPrice =
                totalPrice +
                this.state.subscriptionDetails.subscriptionLength * 15;
        }
        if (
            this.state.subscriptionDetails.subscriptionLength < 12 &&
            this.state.subscriptionDetails.addBidon === true
        ) {
            totalPrice = totalPrice + 80;
        }
        if (
            this.state.subscriptionDetails.subscriptionLength < 3 &&
            this.state.subscriptionDetails.addInfuser === true
        ) {
            totalPrice = totalPrice + 10;
        }
        if (this.state.foundPromotionCode?.value) {
            totalPrice =
                totalPrice -
                totalPrice * (this.state.foundPromotionCode.value * 0.01);
        }
        this.setState({
            totalPrice: totalPrice,
        });
    };

    setQuestionsInState = () => {
        const questions = formQuestions.reduce(
            (prevQuestions, currentQuestion) => {
                return currentQuestion.type === 'singleAnswer'
                    ? prevQuestions.concat({
                          ...currentQuestion,
                          pickedAnswers: '',
                          touched: false,
                      })
                    : prevQuestions.concat({
                          ...currentQuestion,
                          pickedAnswers: [],
                          touched: false,
                      });
            },
            [],
        );
        this.setState({questions});
    };

    nextPageHandler = () => {
        const {activePage, medicalFormPage, questions} = this.state;
        if (activePage === FORM_PAGES_NUMBERS.medicalForm) {
            if (medicalFormPage === questions.length - 1) {
                this.valideNextMainFormStepAndGoTo();
            } else {
                this.valideNextMedicalFormStepAndGoTo();
            }
        } else if (activePage === FORM_PAGES_NUMBERS.summaryPage) {
            this.sendDataToFirebase();
        } else {
            this.valideNextMainFormStepAndGoTo();
        }
    };

    valideNextMainFormStepAndGoTo = () => {
        this.setNextPageClicked(true);
        if (!this.isStepError()) {
            this.nextFormPage('activePage');
            this.setNextPageClicked(false);
        } else {
            this.setCurrentStepError(true);
            this.setInfoBarMessage(
                'Musisz wprowdzić odpowiedź do każdego pola',
            );
            this.setInfoBarVisible(true);
        }
    };

    valideNextMedicalFormStepAndGoTo = () => {
        const {medicalFormPage, questions} = this.state;
        this.setNextPageClicked(true);
        if (
            questions[medicalFormPage].touched &&
            this.pickedAnswersIsNotEmpty()
        ) {
            this.setCurrentStepError(false);
            this.nextFormPage('medicalFormPage');
        } else {
            this.setCurrentStepError(true);
            this.setInfoBarMessage(
                'Musisz zaznaczyć co najmniej jedną odpowiedź',
            );
            this.setInfoBarVisible(true);
        }
    };

    isStepError = () => {
        const {
            activePage,
            subscriptionDetails,
            medicalFormValid,
            contactDetails,
        } = this.state;
        switch (activePage) {
            case FORM_PAGES_NUMBERS.subscriptionDetails:
                return !subscriptionDetails.isValid;
            case FORM_PAGES_NUMBERS.medicalForm:
                return !medicalFormValid;
            case FORM_PAGES_NUMBERS.contactDetails:
                return !contactDetails.isValid;
            default:
                return false;
        }
    };

    setCurrentStepError = error => {
        this.setState({currentStepError: error});
    };

    pickedAnswersIsNotEmpty = () => {
        const {medicalFormPage, questions} = this.state;

        return Array.isArray(questions[medicalFormPage].pickedAnswers)
            ? questions[medicalFormPage].pickedAnswers.length > 0
            : !!questions[medicalFormPage].pickedAnswers;
    };

    setNextPageClicked = clicked => {
        this.setState({nextPageClicked: clicked});
    };

    nextFormPage = form => {
        this.setState(prevState => ({
            [form]: prevState[form] + 1,
        }));
    };

    previousPageHandler = () => {
        const {activePage, medicalFormPage} = this.state;
        if (activePage === FORM_PAGES_NUMBERS.medicalForm) {
            if (medicalFormPage === 0) {
                this.previousFormPage('activePage');
            } else {
                this.previousFormPage('medicalFormPage');
            }
        } else {
            this.previousFormPage('activePage');
        }
    };

    previousFormPage = form => {
        this.setState(prevState => ({
            [form]: prevState[form] - 1,
        }));
    };

    updateSubscriptionDetails = updatedSubscriptionDetails => {
        const subscriptionDetails = updateObject(
            this.state.subscriptionDetails,
            updatedSubscriptionDetails,
        );
        this.setState({subscriptionDetails});
        this.calculateMonthlyPrice();
    };

    updateContactDetails = updatedContactDetails => {
        const contactDetails = updateObject(
            this.state.contactDetails,
            updatedContactDetails,
        );
        this.setState({contactDetails});
        this.calculateMonthlyPrice();
    };

    sendDataToFirebase = async () => {
        const {
            contactDetails,
            subscriptionDetails,
            foundPromotionCode,
        } = this.state;
        const {startLoading} = this.props;
        startLoading();
        const answers = this.getParsedQuestuinsAnswers();

        const newSubscription = {
            ...contactDetails,
            answers,
            subscriptionDetails,
            promotionCode: foundPromotionCode,
            placedDate: new Date(),
        };

        this.props.userDetails
            ? this.loggedUserSubscriptionPlaced(newSubscription)
            : this.unloggedUserSubscriptionPlaced(newSubscription);
    };

    loggedUserSubscriptionPlaced = newSubscription => {
        const {stopLoading} = this.props;
        subscriptionService
            .create(newSubscription)
            .then(response => {
                userService
                    .updateUserData(this.props.userDetails.id, {
                        subscriptionId: response.id,
                    })
                    .then(() => {
                        stopLoading();
                        this.goToSubscriptionPlaced();
                    });
                this.addPromotionCodeUsage(response.id);
            })
            .catch(error => {
                stopLoading();
                console.error(error);
            });
    };

    unloggedUserSubscriptionPlaced = newSubscription => {
        const {stopLoading} = this.props;
        subscriptionService
            .create(newSubscription)
            .then(response => {
                stopLoading();
                this.goToSubscriptionPlaced();
                this.addPromotionCodeUsage(response.id);
            })
            .catch(error => {
                stopLoading();
                console.error(error);
            });
    };

    addPromotionCodeUsage = orderId => {
        if (this.state.foundPromotionCode?.id) {
            const promotionCodeStats = {
                usageDate: new Date(),
                orderId,
            };
            promotionCodeService
                .createNewCodeUsage(
                    this.state.foundPromotionCode.id,
                    promotionCodeStats,
                )
                .catch(console.error);
        }
    };

    goToSubscriptionPlaced() {
        this.setState({activePage: FORM_PAGES_NUMBERS.subscriptionPlaced});
    }

    getParsedQuestuinsAnswers = () =>
        this.state.questions.reduce(
            (previousQuestion, currentQuestion) => ({
                ...previousQuestion,
                [currentQuestion.id]: currentQuestion.pickedAnswers,
            }),
            {},
        );

    checkPromotionCode = promotionCode => {
        const {startLoading, stopLoading} = this.props;
        startLoading();
        promotionCodeService
            .find(promotionCode)
            .then(res => {
                const foundPromotionCode = mapFoundPromotionCodeFromSnapshot(
                    res,
                );
                this.setState({foundPromotionCode});
                this.calculateMonthlyPrice();
                stopLoading();
            })
            .catch(error => {
                console.error(error);
                stopLoading();
            });
    };

    toggleCheckbox = (questionId, optionValue) => {
        const questionsCopy = [...this.state.questions];

        const chengedQuestionIndex = questionsCopy.findIndex(
            question => question.id === questionId,
        );

        const chengedOptionIndex = questionsCopy[
            chengedQuestionIndex
        ].options.findIndex(option => option.value === optionValue);

        const chengedOption = questionsCopy
            .find(question => question.id === questionId)
            .options.find(option => option.value === optionValue);

        const updatedOption = chengedOption.checked
            ? {...chengedOption, checked: !chengedOption.checked}
            : {...chengedOption, checked: true};

        questionsCopy[chengedQuestionIndex].options[
            chengedOptionIndex
        ] = updatedOption;

        const pickedOptionAlreadyExist = questionsCopy[
            chengedQuestionIndex
        ].pickedAnswers.includes(optionValue);

        pickedOptionAlreadyExist
            ? (questionsCopy[
                  chengedQuestionIndex
              ].pickedAnswers = questionsCopy[
                  chengedQuestionIndex
              ].pickedAnswers.filter(answer => answer !== optionValue))
            : questionsCopy[chengedQuestionIndex].pickedAnswers.push(
                  optionValue,
              );

        questionsCopy[chengedQuestionIndex].touched = true;

        this.setState({
            questions: questionsCopy,
            medicalFormValid: this.isAllMedicalQuestionsTouched(),
        });
    };

    setPickedRadioButton = (questionId, optionValue) => {
        const questionsCopy = [...this.state.questions];

        const chengedQuestionIndex = questionsCopy.findIndex(
            question => question.id === questionId,
        );

        questionsCopy[chengedQuestionIndex].pickedAnswers = optionValue;
        questionsCopy[chengedQuestionIndex].touched = true;

        this.setState({
            questions: questionsCopy,
            medicalFormValid: this.isAllMedicalQuestionsTouched(),
        });
    };

    isAllMedicalQuestionsTouched = () =>
        !this.state.questions.some(question => !question.touched);

    setInfoBarVisible = visible => {
        this.setState({infoBarOpen: visible});
    };

    setInfoBarMessage = message => {
        this.setState({infoBarMessage: message});
    };

    render() {
        const {
            activePage,
            medicalFormPage,
            questions,
            contactDetails,
            subscriptionDetails,
            medicalFormValid,
            currentStepError,
            nextPageClicked,
            foundPromotionCode,
            infoBarOpen,
            infoBarMessage,
        } = this.state;

        return (
            <div className={styles.formPage}>
                {activePage === FORM_PAGES_NUMBERS.subscriptionDetails && (
                    <SubscriptionDetails
                        subscriptionDetails={subscriptionDetails}
                        updateSubscriptionDetails={
                            this.updateSubscriptionDetails
                        }
                        price={this.state.monthlyPrice}
                    />
                )}
                {activePage === FORM_PAGES_NUMBERS.medicalForm && (
                    <MedicalForm
                        activePage={medicalFormPage}
                        questions={questions}
                        toggleCheckbox={this.toggleCheckbox}
                        setPickedRadioButton={this.setPickedRadioButton}
                        nextPageHandler={this.nextPageHandler}
                        previousPageHandler={this.previousPageHandler}
                        pushAdditionalGenderQuestions={
                            this.pushAdditionalGenderQuestions
                        }
                    />
                )}
                {activePage === FORM_PAGES_NUMBERS.contactDetails && (
                    <ContactDetais
                        contactDetails={contactDetails}
                        updateContactDetails={this.updateContactDetails}
                    />
                )}
                {activePage === FORM_PAGES_NUMBERS.summaryPage && (
                    <OrderSummary
                        subscriptionDetails={subscriptionDetails}
                        contactDetails={contactDetails}
                        questions={questions}
                        sendDataToFirebase={this.sendDataToFirebase}
                        monthlyPrice={this.state.monthlyPrice}
                        totalPrice={this.state.totalPrice}
                        checkPromotionCode={this.checkPromotionCode}
                        foundPromotionCode={foundPromotionCode}
                    />
                )}
                {activePage === FORM_PAGES_NUMBERS.subscriptionPlaced && (
                    <SubscriptionPlaced />
                )}
                <MainNavigationStepper
                    nextPageHandler={this.nextPageHandler}
                    previousPageHandler={this.previousPageHandler}
                    activePage={activePage}
                    subscriptionDetailsValid={subscriptionDetails.isValid}
                    contactDetailsValid={contactDetails.isValid}
                    medicalFormValid={medicalFormValid}
                    currentStepError={currentStepError}
                    nextPageClicked={nextPageClicked}
                />
                <InfoBar
                    open={infoBarOpen}
                    message={infoBarMessage}
                    infoBarClose={() => this.setInfoBarVisible(false)}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    userDetails: state.auth.userDetails,
});

const mapDispatchToProps = dispatch => ({
    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withLayout(FormPage));
